export const PHONE_REGEX = /^(?:(?:852|00852|\+852)?( )?[2-9][0-9]{7})$/;
